var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-h5"},[_vm._v(" "+_vm._s(_vm.name)+" "),_c('div',{staticClass:"icon",on:{"click":_vm.goSearch}})])
}
var staticRenderFns = []

export { render, staticRenderFns }